import { useGoogleLogin } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import { IConGoogleComponent } from "src/components/images/icon-google";
import "./index.scss";

interface IProps {
  callback?: (accessToken: string) => void;
}

function BtnGoogleLoginComponent({ callback }: IProps) {
  const { t } = useTranslation();

  const loginGG = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      callback && callback(tokenResponse.access_token);
    },
  });

  return (
    <div className="btn btn-google" onClick={() => loginGG()}>
      <IConGoogleComponent />
      <div>{t("login.form.googleButton")}</div>
    </div>
  );
}

export default BtnGoogleLoginComponent;
